import { Modulators } from "@opendaw/studio-adapters";
export class ProjectModulation {
    #project;
    constructor(project) { this.#project = project; }
    get kinds() { return Modulators.Kinds; }
    adapters() {
        return this.#project.rootBoxAdapter.modulators.adapters();
    }
    create(kind) {
        return kind.create(this.#project);
    }
    createLfo(label) { return Modulators.createLfo(this.#project, label); }
    createSteps(label) { return Modulators.createSteps(this.#project, label); }
    createMacro(label) { return Modulators.createMacro(this.#project, label); }
    createRandom(label) { return Modulators.createRandom(this.#project, label); }
    assign(modulator, target, depth) {
        return Modulators.assign(this.#project, modulator, target, depth);
    }
    replace(modulator, kind) {
        return Modulators.replace(this.#project, modulator, kind);
    }
    duplicate(modulator) {
        return Modulators.duplicate(this.#project, modulator);
    }
    duplicateAll(modulators) {
        return Modulators.duplicateAll(this.#project, modulators);
    }
    delete(modulator) { this.deleteAll([modulator]); }
    deleteAll(modulators) {
        Modulators.deleteAll(this.#project, modulators);
    }
    move(modulators, target) {
        Modulators.move(this.#project, modulators, target);
    }
}
